import type { ValueOf } from 'type-fest';

export const TrackedEventKeys = {
  Click: 'Click',
  CheckboxClick: 'Checkbox click',
  LinkClicked: 'Link clicked',
  SelectionSubmitted: 'Selection submitted',
  DialogViewed: 'Dialog viewed',
  ReportExported: 'Report exported',
  BannerViewed: 'Banner viewed',
  ThirdPartyAppStateChanged: 'Third party app state changed',
  FormFieldFilled: 'Form field filled',
  BankAccountSetup: 'Bank account setup',
  PhoneNumberSelected: 'Phone number selected',
};

export const TrackedGlobalEvents = {
  SearchPerformed: 'Search performed',
};

export const TrackedDialogEventsKeys = {
  Open: 'open',
  Close: 'close',
};

export type TrackedEventKeysType = ValueOf<typeof TrackedEventKeys>;

export type TrackedDialogEventsKeysType = ValueOf<typeof TrackedDialogEventsKeys>;
